import { render, staticRenderFns } from "./applyList_wx.vue?vue&type=template&id=1167d175&scoped=true"
import script from "./applyList_wx.vue?vue&type=script&lang=js"
export * from "./applyList_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1167d175",
  null
  
)

export default component.exports